<div
  *ngIf="totalItems"
  class="flex flex-wrap items-center justify-between gap-3 py-3"
>
  <div class="flex items-center gap-3 px-4">
    <label *ngIf="showPageSize" class="flex items-center gap-2 text-sm text-muted page-size">
      <span class="page-size__label">Rows per page</span>
      <select
        class="page-size__select"
        [ngModel]="pageSize"
        (ngModelChange)="onPageSizeChange($event)"
        [disabled]="disabled"
        aria-label="Rows per page"
      >
        <option *ngFor="let size of resolvedPageSizeOptions" [ngValue]="size">
          {{ size }}
        </option>
      </select>
    </label>

    <span class="text-sm text-muted">
      <!-- Where the footer is too narrow to hold the long form beside the page
           buttons, the count drops to a short one. Left long, it pushes the
           buttons onto a second line and the footer grows a row taller than the
           footer of a wider panel beside it. -->
      <span class="range-long">
        Showing {{ rangeStart }} to {{ rangeEnd }} of {{ totalItems }} results
      </span>
      <span class="range-short">
        {{ rangeStart }}&ndash;{{ rangeEnd }} of {{ totalItems }}
      </span>
    </span>
  </div>

  <div class="flex items-center gap-1">
    <button
      type="button"
      class="pager-btn"
      (click)="goToPage(page - 1)"
      [disabled]="page === 1 || disabled"
      aria-label="Previous page"
    >
      <mat-icon class="pager-icon">chevron_left</mat-icon>
    </button>

    <span *ngIf="sequential" class="px-2 text-sm text-muted">
      Page {{ page }} of {{ totalPages }}
    </span>

    <ng-container *ngIf="!sequential">
      <ng-container *ngFor="let item of pageItems">
        <span *ngIf="item === '…'" class="px-2 text-sm text-muted select-none">
          &hellip;
        </span>
        <button
          *ngIf="item !== '…'"
          type="button"
          class="pager-btn"
          [class.pager-btn--active]="item === page"
          (click)="goToPage(item)"
          [disabled]="disabled"
          [attr.aria-current]="item === page ? 'page' : null"
        >
          {{ item }}
        </button>
      </ng-container>
    </ng-container>

    <button
      type="button"
      class="pager-btn"
      (click)="goToPage(page + 1)"
      [disabled]="page === totalPages || disabled"
      aria-label="Next page"
    >
      <mat-icon class="pager-icon">chevron_right</mat-icon>
    </button>
  </div>
</div>
